const features = [
    {
        icon: 'las la-brain',
        heading: 'Backed by Science',
        excerpt: 'Red Maca contains glucosinolates and plant sterols that help regulate hormone production and support adrenal balance—naturally.',
    },
    {
        icon: 'las la-seedling',
        heading: 'Rooted in Tradition',
        excerpt: 'Used by Andean women for centuries to improve energy, fertility, and emotional wellness—Red Maca is a time-tested natural remedy.',
    },
    {
        icon: 'las la-leaf',
        heading: '100% Pure & Organic',
        excerpt: 'Grown at high altitudes in Peru, our Red Maca is certified organic, caffeine-free, non-GMO, and processed in a certified facility.',
    },
    {
        icon: 'las la-smile-beam',
        heading: 'Feel the Effect',
        excerpt: 'Women report better mood, energy, focus, and intimacy within weeks of consistent use. Your wellness routine just got an upgrade.',
    },
    {
        icon: 'las la-spa',
        heading: 'Gentle on Your Body',
        excerpt: 'Unlike synthetic supplements or stimulants, Red Maca works with your body’s natural rhythms. It gently adapts to your needs without causing dependence, digestive issues, or hormonal overload—making it perfect for daily, long-term use.',
    },
    {
        icon: 'las la-shield-alt',
        heading: 'Trusted & Transparent',
        excerpt: 'Every batch of our Red Maca is traceable, tested, and crafted with full transparency. From our farmers in the Andes to our FDA-registered facility, you can trust what you’re putting in your body—because we do, too.',
    }
];

export default features;